import { render, staticRenderFns } from "./barchart.vue?vue&type=template&id=5f878f2b&scoped=true"
import script from "./barchart.vue?vue&type=script&lang=js"
export * from "./barchart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f878f2b",
  null
  
)

export default component.exports